export const PwaPage = {
  DisabledIos: 'DisabledIos',
  DisabledAndroid: 'DisabledAndroid',
  InstallSafari: 'InstallSafari',
  InstallOldSafari: 'InstallOldSafari',
  InstallChrome: 'InstallChrome',
  InstallOther: 'InstallOther',
  InstallDesktop: 'InstallDesktop',
};

export type PwaPage = Union<typeof PwaPage>;
